import { Portal } from '@chakra-ui/react';

import { CloseButton } from '../CloseButton';
import { DialogOrDrawer } from '../DialogOrDrawer';
import { DefaultContent } from './components/DefaultContent';
import { useAccountDialog } from './useAccountDialog';

// todo cover.lv remove this accountDialog after profileDrawer release
export const AccountDialog = () => {
  const isOpen = useAccountDialog((s) => s.isOpen);
  const close = useAccountDialog((s) => s.close);

  return (
    <DialogOrDrawer.Root
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      scrollBehavior="inside"
      open={isOpen}
      onOpenChange={(state) => !state.open && close()}
    >
      <Portal>
        <DialogOrDrawer.Backdrop />
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent
            minH={{
              desktopDown: '70vh',
            }}
          >
            <DialogOrDrawer.CloseTrigger asChild>
              <CloseButton />
            </DialogOrDrawer.CloseTrigger>
            <DialogOrDrawer.Header>
              <DialogOrDrawer.Title>My account</DialogOrDrawer.Title>
            </DialogOrDrawer.Header>
            <DefaultContent />
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
